// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G9Ibr","content":"styles_content__1Jg9y"};